import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, Icon, Label } from "semantic-ui-react";
import { toggleSidebar } from "../../redux/actions/";
import { useDispatch, useSelector } from "react-redux";

const CartIcon = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cartItems);

  if (props.small)
    return (
      <Menu.Item
        style={{ fontFamily: "Avenir Next Codensed Regular" }}
        className={"header-text-left"}
        key={"checkout"}
        as={Link}
        onClick={() => dispatch(toggleSidebar(false))}
        to={`/checkout#checkout-data`}
      >
        {t(`header-menu-cart`)}
        {cartItems > 0 && (
          <Label circular color="lg-brown">
            {cartItems}
          </Label>
        )}
      </Menu.Item>
    );

  if (props.sticky)
    return (
      <div
        style={{
          position: "fixed",
          top: "calc(34px + env(safe-area-inset-top))",
          right: "24px",
          zIndex: 1000,
        }}
      >
        <Menu.Item key={"checkout"} as={Link} to={`/checkout#checkout-data`}  style={{
            background: '#000',
            borderRadius: '50%',
            width: '84px',
            height: '84px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          }}>
          <Icon.Group>
            <Icon name="shopping cart" inverted color={"grey"} size="big" />
            {cartItems > 0 && (
              <Label circular color="lg-brown" floating style={{
                  top: '-6px',
                  right: '-6px',
                }}>
                {cartItems}
              </Label>
            )}
          </Icon.Group>
        </Menu.Item>
      </div>
    );
  
  return (
    <Menu.Item key={'checkout'} as={Link} to={`/checkout#checkout-data`} >
      <Icon.Group>
        <Icon name='shopping cart' inverted color={'grey'} size="big" />
        {cartItems > 0 &&
          <Label circular color='lg-brown' floating style={{
              top: '-6px',
              right: '-6px',
            }}> {cartItems}
          </Label>}
      </Icon.Group>
    </Menu.Item>
  );
};

export default CartIcon;
